import React from 'react';
import Icon from './Icon';

const HouseIcon = (props) => (
    <Icon {...props}>
        <path
            d="M2 10.5L12 3L22 10.5M16.5 6.5V3H19.5V8.8M4 10V20A1 1 0 0 0 5 21H19A1 1 0 0 0 20 20V10M6.5 21V14H10V21M14 13.5H17.5V17H14Z"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default HouseIcon;
